/**
 * 5-color palette for project task states (Phase 20 D-09).
 *
 * Values are copied VERBATIM from
 * `.planning/phases/17-schema-legacy-migration/17-CONTEXT.md` D-11
 * — the Phase 17 deterministic-by-index palette used by both the
 * Minimal seed and per-project Legacy templates. Do NOT change without
 * coordinating with Phase 17 dual-write expectations.
 *
 * (Phase 20 D-09 mentions `#ef4444` for the last entry — that's a typo
 *  in the CONTEXT.md; Phase 17 D-11 — `#f43f5e` rose-500 — is canonical.)
 *
 * Used by:
 *   - StateColorPickerPopover (frontend/src/components/domain/StateColorPickerPopover.tsx)
 *     — renders these as click-to-pick swatches.
 *   - StateListEditor (frontend/src/components/domain/StateListEditor.tsx)
 *     — picks the next-available palette color when "+ Add state" is clicked.
 */
export const STATE_PALETTE = [
  '#64748b', // slate-500
  '#3b82f6', // blue-500
  '#f59e0b', // amber-500
  '#10b981', // emerald-500
  '#f43f5e', // rose-500
] as const;

export type StatePaletteColor = (typeof STATE_PALETTE)[number];
